export default (url) => {
	let nameplate;
	if (url?.indexOf?.('search/') > -1 && url?.indexOf?.('-') > -1) {
		const str = url.split('search/')[1].split('-');
		nameplate = str.length >= 2 && `${str[1]} ${str[2]}`.toLowerCase();
	}

	return nameplate;
};
